import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
export var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var block = _ref.block,
    bold = _ref.bold,
    centered = _ref.centered,
    correctFootprint = _ref.correctFootprint,
    designContext = _ref.designContext,
    designVersion = _ref.designVersion,
    disabled = _ref.disabled,
    error = _ref.error,
    inverseOnBackground = _ref.inverseOnBackground,
    light = _ref.light,
    metadata = _ref.metadata,
    medium = _ref.medium,
    overflowEllipsisWidth = _ref.overflowEllipsisWidth,
    rightAligned = _ref.rightAligned,
    success = _ref.success,
    warning = _ref.warning,
    white = _ref.white;
  return {
    viewStyle: _objectSpread(_objectSpread({}, correctFootprint ? block ? {
      marginBottom: -10,
      marginTop: -5
    } : {
      marginBottom: -10,
      marginTop: -10
    } : {
      marginBottom: 0,
      marginTop: 0
    }), block ? {
      paddingBottom: 5,
      paddingTop: 0
    } : {
      paddingBottom: 3,
      paddingTop: 2
    }),
    textStyle: _objectSpread(_objectSpread(_objectSpread({
      color: error ? Colors.__textError(designVersion).toString() : warning ? Colors.__textWarning(designVersion).toString() : success ? Colors.__textSuccess(designVersion).toString() : disabled ? Colors.__textDisabled(designVersion).toString() : light ? Colors.__textNeutral(designVersion).toString() : metadata ? Colors.__textNeutral(designVersion).toString() : inverseOnBackground ? Colors.__textInverseOnBackground(designVersion).toString() : white ? Colors.__textInverse(designVersion).toString() : Colors.__textDefault(designVersion).toString()
    }, bold ? designContext.get('text-style/text/super-paragraphs/body/bold').styles() : medium ? designContext.get('text-style/text/super-paragraphs/body/medium').styles() : designContext.get('text-style/text/super-paragraphs/body/regular').styles()), {}, {
      lineHeight: block ? 20 : 25,
      WebkitFontSmoothing: 'antialiased',
      textAlign: centered ? 'center' : rightAligned ? 'right' : 'left'
    }, overflowEllipsisWidth && {
      maxWidth: overflowEllipsisWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map